/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type JobEventCreated_job$ref: FragmentReference;
export type JobEventCreated_job = {|
  +uuid: string,
  +createdAt: ?any,
  +agentQueryRules: ?$ReadOnlyArray<string>,
  +step: ?{|
    +uuid: string,
    +key: ?string,
    +conditional: ?string,
    +dependencies: ?{|
      +edges: ?$ReadOnlyArray<?{|
        +node: ?{|
          +uuid: string,
          +key: ?string,
        |}
      |}>
    |},
  |},
  +$refType: JobEventCreated_job$ref,
|};
*/


const node/*: ConcreteFragment*/ = (function(){
var v0 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "uuid",
  "args": null,
  "storageKey": null
},
v1 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "key",
  "args": null,
  "storageKey": null
};
return {
  "kind": "Fragment",
  "name": "JobEventCreated_job",
  "type": "JobTypeCommand",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    v0,
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "createdAt",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "agentQueryRules",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "step",
      "storageKey": null,
      "args": null,
      "concreteType": "StepCommand",
      "plural": false,
      "selections": [
        v0,
        v1,
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "conditional",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "dependencies",
          "storageKey": "dependencies(first:10)",
          "args": [
            {
              "kind": "Literal",
              "name": "first",
              "value": 10,
              "type": "Int"
            }
          ],
          "concreteType": "DependencyConnection",
          "plural": false,
          "selections": [
            {
              "kind": "LinkedField",
              "alias": null,
              "name": "edges",
              "storageKey": null,
              "args": null,
              "concreteType": "DependencyEdge",
              "plural": true,
              "selections": [
                {
                  "kind": "LinkedField",
                  "alias": null,
                  "name": "node",
                  "storageKey": null,
                  "args": null,
                  "concreteType": "Dependency",
                  "plural": false,
                  "selections": [
                    v0,
                    v1
                  ]
                }
              ]
            }
          ]
        }
      ]
    }
  ]
};
})();
// prettier-ignore
(node/*: any*/).hash = 'aea193e90eebe9e572a7ffef17eef732';
module.exports = node;
